

<template>
  <div>

      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li>
                          <button v-if="bundleSharingEnableFlag" type="button" @click="shareEntity()" ><i class="fa fa-share-alt fa-2x push-15-r "></i></button>
                      </li>

                      <li v-if="flagDisplaySubBundle===0">
                          <button type="button" @click="toggleDisplaySubBundle()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplaySubBundle">
                          <button  type="button" @click="toggleDisplaySubBundle()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplaySubBundle()"><i class="fa fa-usb fa-1x push-5-r "></i>{{tempoBundle.sub_bundle[subBundleIndex].ReferenceName}}</h2>
            </div>

            <div v-if="flagDisplaySubBundle" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Static Labels -->
                    <div class="block">

                      <div class="col-xs-12 push">
                        <div class="form-group">
                            <label class="col-xs-12">{{ textLabelReferenceName[actualLanguage] }}</label>
                            <div class="col-sm-12">
                                <input v-model="tempoBundle.sub_bundle[subBundleIndex].ReferenceName" class="form-control"  placeholder="Entrez votre information">
                            </div>
                        </div>
                      </div>

                      <div class="col-xs-12 col-md-6 push" >
                        <p>{{ sectionTitleDisplayMA[actualLanguage] }} </p>
                        <label  class="css-input switch switch-success">
                            <input type="checkbox" checked v-model="tempoBundle.sub_bundle[subBundleIndex].computeSumOfMovingAverageValue">
                            <span></span> {{ buttonLabelMA_Option[actualLanguage] }}
                        </label>
                      </div>

                      <div class="col-xs-12 col-md-6">
                        <div class="form-group appliance-list-wrap">
                          <p><img @click="showSystemsList = !showSystemsList" width="100px" :src="`systems_icons/${tempoBundle.sub_bundle[subBundleIndex].subBundleData.bundle_icon}` | s3Image"></p>
                          <button @click="showSystemsList = !showSystemsList" type="button" class="btn btn-big btn-primary btn-rounded" name="button"><i class='fa fa-pencil'></i></button>
                          <systems-list @onSelect="onSystemSelect" class="systems-list" v-if="showSystemsList"></systems-list>
                        </div>
                      </div>


                      <div v-if="actualBundle.channelsAttributes.length > 0" class="col-xs-12" >
                          <h5 class="push">{{ sectionLabelSubSystemTag[actualLanguage] }}</h5>
                          <div v-for = "(categoryList ,index) in actualBundle.channelsAttributes">
                              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4">
                                  <div class="form-group">
                                      <label class="col-xs-12" for="example-select">{{categoryList.title}}</label>
                                        <div class="col-sm-12">
                                            <select class="form-control" v-model="tempoBundle.sub_bundle[subBundleIndex].Attributes[index]" id="example-select" name="example-select" size="1">
                                                <option v-for= "(element, index2) in categoryList.data" :value="element">{{element}}</option>
                                            </select>
                                        </div>
                                  </div>
                              </div>
                          </div>
                      </div>



                      <div class="col-xs-12 push"><hr></hr></div>

                      <div v-if="bundleConfigViewFlag" class="col-xs-12 items-push">
                        <h5 >{{ labelSectionSubSystemConfiguration[actualLanguage] }}</h5>
                    

                        <div class="col-xs-12 col-md-12">
                          <div class="form-group">
                              <label class="col-xs-12">{{ textLabelSubSystemName[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <input v-model="tempoBundle.sub_bundle[subBundleIndex].subBundleData.bundle_name" class="form-control" type="test" id="lock1-password" name="lock1-password" placeholder="Entrez votre information">
                              </div>
                          </div>
                        </div>

                        <div class="col-xs-12 items-push" >
                          <div  class="col-xs-12 col-md-6">
                            <button v-if="bundleConfigDeleteFlag" type="button" style="color:white" @click="confirmRemoveSubBundle()" class="btn btn-danger" name="buttonDeletePlanItem2">
                              <spinner size="small" v-if="subBundleIsDeleting"></spinner>
                              <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ buttonDeleteSystem[actualLanguage] }}</span></button>
                          </div>

                          <div  class="col-xs-12 col-md-6">
                            <p><button v-if="bundleConfigEditFlag" @click="saveSubBundleModifications()" type="button" class="btn btn-success align-right" name="button">
                              <spinner size="small" v-if="subBundleIsSaving"></spinner>
                              <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ buttonSaveThisSubSystem[actualLanguage] }}</span></button></p>
                          </div>
                        </div>

                    </div>

                    </div>
                    <!-- END Static Labels -->
                </div>
              </div>

            </div>
        </div>
      </div>
      </div>
    </div>
  </div>


</template>

<script>


import _ from 'underscore'
import {mapState, mapGetters,mapActions} from 'vuex'
import Spinner from '../../components/Spinner.vue'
import SystemsList from '@/views/configuration/SystemsList'

export default {
  props: ['subBundleIndex'],
  components: {
    Spinner,
    SystemsList
  },
  data() {
    return {
      tempoBundle : {},
      flagDisplaySubBundle : 0,
      //alertsDefinitions : alertDef,
      subBundleIsSaving : false,
      subBundleIsDeleting : false,
      showSystemsList : false,
        
      actualLanguage : "FR",
      labelTableTop: {FR: 'Afficher le tableau des données', EN: 'Display data table'},

      bundleConfigViewFlag : false,
      bundleConfigEditFlag : false,
      bundleConfigDeleteFlag : false,
      bundleSharingEnableFlag : false,

      textLabelReferenceName: {FR: "Nom de référence", EN: 'Referencen name'},
      sectionTitleDisplayMA: {FR: "Option affichage de moyenne mobile du sous-système", EN: 'Display option for sub-system moving average'},
      buttonLabelMA_Option:{FR: "Calculer la somme des appareils et sous-systèmes.", EN: 'Compute the device and sub-system summation'},
      sectionLabelSubSystemTag:{FR: "Étiquettes du sous-système", EN: 'Sub-system tags'},
      labelSectionSubSystemConfiguration:{FR: "Configuration du Sous-Système", EN: 'Sub-System configuration'},
      textLabelSubSystemName:{FR: "Nom du System", EN: 'System name'},
      buttonDeleteSystem:{FR: "Supprimer ce Sous-Système", EN: 'Delete this Sub-System'},
      buttonSaveThisSubSystem:{FR: "Enregistrer les paramètres du Sous-Système", EN: 'Save Sub-System parameters'},
      subBundleSaveMessage:{FR: "Attention, si le nom de référence a été modifié, il est possible que la position dans la liste soit modifiée!",
                      EN: "Attention, if the reference name changed, it is possible that the system position in the list change!"},

      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du Sous-Système : ", EN: 'Confirm Sub-System deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},

    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','parentContainer']),
    ...mapState('overlayStore', ['overlayParameters']),
  },
  watch: {
    actualBundle(){
        this.reloadTempoBundle()
    },
  },

  methods: {
  ...mapActions('overlayStore', ['showModal']),

   toggleDisplaySubBundle(){
      this.flagDisplaySubBundle = ~this.flagDisplaySubBundle
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },

    onSystemSelect(a) {
      this.showSystemsList = false
      //console.log(a)
      //this.portModel.portName = a.name
      //this.portModel.voltage  = a.voltage
      this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.bundle_icon = a.iconFile
      //this.tempoBundle.bundle_icon = a.iconFile
    },


    saveSubBundleModifications() {
        this.subBundleIsSaving = true
        var requestData = { 'postAction':'SaveSubBundleModification',
                            'parentContainer':this.parentContainer,
                            'bundleId': this.tempoBundle.bundle_id,
                            'subBundleIndex': this.tempoBundle.sub_bundle[this.subBundleIndex].SubBundleBundleIndex,
                            'subBundleItem':this.tempoBundle.sub_bundle[this.subBundleIndex],
                            }
                            //console.log(requestData)
        this.$store.dispatch('sessionStore/postBundle', requestData)
            .then((response) => {
              //console.log(response.data)
              this.subBundleIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                //this.alertShowAddButton=true
                window.alert(this.subBundleSaveMessage[this.actualLanguage])
                this.$store.dispatch('sessionStore/reloadActualBundle')
                this.$store.dispatch('sessionStore/getGroupArborescence')
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage])}
            })       
    },


    confirmRemoveSubBundle(){
          var FlagProcessToDelete = false
          var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.tempoBundle.sub_bundle[this.subBundleIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

          if(confirmation == 'DELETE'){
              this.subBundleIsDeleting = true
              var requestData = { 'postAction':'RemoveSubBundleFromBundle',
                                  'parentContainer':this.parentContainer,
                                  'bundleId': this.tempoBundle.bundle_id,
                                  'subBundleIndex': this.tempoBundle.sub_bundle[this.subBundleIndex].SubBundleBundleIndex,
                                  'subBundleItem':this.tempoBundle.sub_bundle[this.subBundleIndex],
                                  }
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                    this.subBundleIsDeleting = false
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                       this.$store.dispatch('sessionStore/reloadActualBundle')
                      }
                      else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
                  })       
          }
    },


    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage de sous Systèmes", EN: 'Sub systems sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Bundle',
                        'entityId':this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.bundle_id,
                        'entityReferenceName':this.tempoBundle.sub_bundle[this.subBundleIndex].ReferenceName,
                        'displayAlertOptions':true,
                        'displayChannelOptions':true,
                        'displayDeviceOptions':true,
                        'displayBundleOptions':true,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },


    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value
          //console.log('Value Found')
          //console.log(value)
          }
        }
        return value
    },


  },

  mounted() {
    //console.log(this.tempoBundle.permissions.bundle)
    //this.bundleConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.permissions.bundle,'bundleConfigView')
    this.bundleConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle,'bundleConfigView')

    //this.bundleConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.permissions.bundle,'bundleConfigEdit')
    this.bundleConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle,'bundleConfigEdit')

    //this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.permissions.bundle,'bundleConfigDelete')
    this.bundleConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.permissions.bundle,'bundleConfigDelete')

    this.bundleSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.sub_bundle[this.subBundleIndex].subBundleData.permissions.bundle,'bundleSharingEnable')

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
  },


  beforeMount(){
    this.reloadTempoBundle()
  }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConfigSubBundle.vue?571f38c7